import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { RowLockProvider } from './context/RowLockContext';
import ClientList from './components/ClientList';
import Engagement from './components/Engagement';
import Invoice from './components/Invoice';
import KPI from './components/KPI';
import TimeSheet from './components/TimeSheet';
import AnnualLeave from './components/AnnualLeave';
import Calendar from './components/Calendar';
import LoginPage from './components/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <AppProvider>
          <RowLockProvider>
            <Router>
              <div className="App">
                <Routes>
                  {/* Public route for login */}
                  <Route path="/login" element={<LoginPage />} />

                  {/* Protected routes - all routes that require authentication go here */}
                  <Route element={
                    <ProtectedRoute>
                      <Layout />
                    </ProtectedRoute>
                  }>
                    <Route path="/" element={<ClientList />} />
                    <Route path="/client-list" element={<ClientList />} />
                    <Route path="/engagement" element={<Engagement />} />
                    <Route path="/invoice" element={<Invoice  />} />
                    <Route path="/kpi" element={<KPI />} />
                    <Route path="/time-sheet" element={<TimeSheet />} />
                    <Route path="/annual-leave" element={<AnnualLeave />} />
                    <Route path="/calendar" element={<Calendar />} />
                  </Route>

                  {/* Redirect any other route to login if not authenticated */}
                  <Route path="*" element={<Navigate to="/login" />} />
                </Routes>
              </div>
            </Router>
          </RowLockProvider>
        </AppProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;